export default __webpack_public_path__ + "static/media/regreen_visual_04.33cbd1a4.jpg";